import { useRef, useState, useEffect } from "react";
import { getBrands, getContactTypes, getConsents } from "../../api/axios"
import { validateDate } from "../../utilities/Utils"
import useAuth from "../../hooks/useAuth";

const DashboardFilters = ({ setIdBrand, setIdContactType, setDateFrom, setDateUntil, setIdConsent, setYear, onDownload }) => {

    const dateFromRef = useRef();
    const dateUntilRef = useRef();
    const yearRef = useRef();

    const [isLoading, setIsLoading] = useState(true);
    const idBrandRef = useRef();
    const [idBrands, setIdBrands] = useState([]);
    
    const idContactTypeRef = useRef();
    const [idContactTypes, setIdContactTypes] = useState([]);
    
    const idConsentRef = useRef();
    const [idConsents, setIdConsents] = useState([]);

    const [years, setYears] = useState([]);
    
    const { auth } = useAuth();

    useEffect(() => {
    
        const currentYear = new Date().getFullYear();
        const yearsList = [];

        for (let y = currentYear; y >= 2015; y--) {
            yearsList.push(y);
        }

        setYears(yearsList);

    }, []);

    useEffect(() => {

        const fetchData = async () => {
          
          setIsLoading(true);
          
          try {
            
            let data;

            data = await getBrands({ auth });
            setIdBrands(data.results);

            data = await getContactTypes({ auth });
            setIdContactTypes(data.results);

            data = await getConsents({ auth });
            setIdConsents(data.results);
    
          } catch (error) {
    
            setIdBrands(null);
            setIdContactTypes(null);
            setIdConsents(null);
    
          }
    
          setIsLoading(false);
    
        };
    
        fetchData();
        
    }, [auth]);

    const collectFilters = () => ({
        idBrand: idBrandRef.current?.value ?? '0',
        idContactType: idContactTypeRef.current?.value ?? '0',
        idConsent: idConsentRef.current?.value ?? '0',
        dateFrom: dateFromRef.current?.value ?? '',
        dateUntil: dateUntilRef.current?.value ?? '',
        year: yearRef.current?.value ?? '',
    });

    const applyFilters = (filters) => {
        setIdBrand(filters.idBrand);
        setIdConsent(filters.idConsent);
        setIdContactType(filters.idContactType);
        setDateFrom(filters.dateFrom);
        setDateUntil(filters.dateUntil);
        setYear && setYear(filters.year);
    };

    const validateFilters = (filters) => {
        if (filters.dateFrom && !validateDate(filters.dateFrom)) {
            alert('La fecha desde ingresada no es válida.');
            return false;
        }

        if (filters.dateUntil && !validateDate(filters.dateUntil)) {
            alert('La fecha hasta ingresada no es válida.');
            return false;
        }

        return true;
    };

    const handleSubmit = (event) => {

        event.preventDefault();

        const filters = collectFilters();

        if (!validateFilters(filters)) {
            return;
        }

        applyFilters(filters);

    };

    const handleYearChange = (e) => {
        const selectedYear = e.target.value;

        if (selectedYear) {
            const janFirst = `${selectedYear}-01-01`;
            const decLast = `${selectedYear}-12-31`;

            if (dateFromRef.current) dateFromRef.current.value = janFirst;
            if (dateUntilRef.current) dateUntilRef.current.value = decLast;
        } else {
            // Si no hay año seleccionado, limpiar los inputs
            if (dateFromRef.current) dateFromRef.current.value = "";
            if (dateUntilRef.current) dateUntilRef.current.value = "";
        }
    };


    const handleDateChange = () => {

        if (yearRef.current) {
            yearRef.current.value = '';
        }

    };
  


    return (
        <>

          <div className="filters_div">

          <form action="" onSubmit={handleSubmit}>

              <ul className="filters_row">

                  <li>
                      <label htmlFor="idBrand">
                          <span>Marca</span>
                          <select 
                              ref={idBrandRef}
                              id="idBrand" 
                              name="idBrand" 
                          >
                              <option value="0">Todas</option>
                              
                              {!isLoading && idBrands && idBrands?.map((option, index) => (
                                  <option key={index} value={option.id}>
                                  {option.name}
                                  </option>
                              ))}
                          
                          </select>
                      </label>
                  </li>

                  <li>
                      <label htmlFor="idContactType">
                          <span>Tipo de destinatario</span>
                          <select 
                              ref={idContactTypeRef}
                              id="idContactType" 
                              name="idContactType" 
                          >
                              <option value="0">Todos</option>
                              
                          {!isLoading && idContactTypes && idContactTypes?.map((option, index) => (
                              <option key={index} value={option.id}>
                              {option.name}
                              </option>
                          ))}
                          
                          </select>
                      </label>
                  </li>

                  <li>
                      <label htmlFor="idConsent">
                          <span>Consentimiento</span>
                          <select 
                              ref={idConsentRef}
                              id="idConsent" 
                              name="idConsent" 
                          >
                              <option value="0">Otros (offline)</option>
                              
                          {!isLoading && idConsents && idConsents?.map((option, index) => (
                              <option key={index} value={option.id}>
                              {option.name}
                              </option>
                          ))}
                          
                          </select>
                      </label>
                  </li>

              </ul>

              <ul className="filters_row">

                  <li>
                      <label htmlFor="dateFrom">
                      <span>Fecha Desde</span>
                      <input 
                          ref={dateFromRef}
                          name="dateFrom" 
                          type="date"
                          placeholder="YYYY-MM-DD"    
                          className="w--130 center"
                          onChange={handleDateChange}
                      />
                      </label> 
                  </li>

                  <li>
                      <label htmlFor="dateUntil">
                      <span>Fecha Hasta</span>
                      <input 
                            ref={dateUntilRef}
                            name="dateUntil" 
                            type="date"
                            placeholder="YYYY-MM-DD"
                            className="w--130 center"
                            onChange={handleDateChange}
                      />
                      </label> 
                  </li>

                  <li>
                      <label htmlFor="year">
                          <span>Año</span>
                          <select 
                          ref={yearRef}
                          id="year"
                          name="year"
                          className="w--110 center"
                          onChange={handleYearChange}
                          >
                          <option value="">Todos</option>
                          {years.map((year, index) => (
                              <option key={index} value={year}>
                              {year}
                              </option>
                          ))}
                          </select>
                      </label>
                  </li>

                  <li>
                      <button className="button-outline" type="submit">Buscar</button>
                  </li>

                  {typeof onDownload === 'function' && (
                  <li>
                      <button
                        className="button-outline"
                        type="button"
                        onClick={() => {
                          const filters = collectFilters();
                          if (!validateFilters(filters)) {
                            return;
                          }
                          applyFilters(filters);
                          onDownload(filters);
                        }}
                      >
                        Descargar
                      </button>
                  </li>
                  )}

              </ul>

          </form>

          </div>


        </>
    )
}

export default DashboardFilters
